import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Retro-style section heading with a pill eyebrow label,
 * big Fredoka headline, and optional description.
 */
const SectionHeading = ({
  eyebrow,
  title,
  description,
  align = "left",
  eyebrowColor = "#FF6B6B",
  eyebrowBg   = "#FFE8E8",
  dark = false,
}) => {
  return (
    <Box sx={{ mb: { xs: 5, md: 6 }, textAlign: align }}>
      {eyebrow && (
        <Box
          component="span"
          sx={{
            display: "inline-block",
            px: 2,
            py: 0.5,
            mb: 2,
            borderRadius: "8px",
            border: "2px solid",
            borderColor: eyebrowColor,
            backgroundColor: eyebrowBg,
            color: eyebrowColor,
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 800,
            fontSize: "0.78rem",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
          }}
        >
          {eyebrow}
        </Box>
      )}
      <Typography
        variant="h2"
        sx={{
          fontFamily: "'Fredoka One', cursive",
          fontSize: { xs: "2rem", sm: "2.6rem", md: "3.2rem" },
          lineHeight: 1.15,
          color: dark ? "#FFF8F0" : "#1B1F3B",
          mb: description ? 2.5 : 0,
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          sx={{
            fontSize: { xs: "1rem", md: "1.1rem" },
            color: dark ? "rgba(255,248,240,0.78)" : "#4A4E6D",
            lineHeight: 1.8,
            maxWidth: align === "center" ? 640 : "none",
            mx: align === "center" ? "auto" : 0,
            fontWeight: 600,
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default SectionHeading;
